/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/

// Derives the currently switched-into scope the same way the backend does
export const getScopeLevel = (user) => {
  if (!user?.accountUID) { return 'platform'; }
  if (!user?.subAccountUID) { return 'account'; }
  return 'sub_account';
};

// True when any of the user's role keys matches one of `keys` (case-insensitive)
export const hasAnyRoleKey = (user, keys = []) => (
  keys.some((k) => user?.roleKeys?.some((key) => key.toLowerCase() === k.toLowerCase()))
);

// Live session namespace scopes to the user's tenant: sub-account first, then
// account, falling back to the shared portal-wide namespace for platform users.
export const getLiveSessionNamespace = (user) => (
  user?.subAccountUID || user?.accountUID || process.env.REACT_APP_LIVE_SESSION_NAMESPACE
);

// Name shown beside the branding logo: active sub-account, then account,
// falling back to the platform name when no account is selected.
export const getBrandName = (user, accountName) => (
  user?.subAccountName || accountName || user?.accountName || 'ServiceHub'
);
